import { Range } from "ts/range";

export const DEFAULT_ALERT_RANGE: Range = { min: 0, max: 100 };
